import { ModuleDetails } from '../../../../types/theory/module';
import { Col, Row } from 'react-bootstrap';

const ModuleImageAndTitle = ({ module }: { module: ModuleDetails }) => {
    return (
        <Row>
            <Col xxl={1} md={2} sm={3} className={'text-center'}>
                <img src={module.thumbnail.url} alt='' className='img-fluid' style={{ maxHeight: 100 }} />
            </Col>
            <Col xxl={11} md={10} sm={9}>
                <Row>
                    <Col>
                        <h2 className={'text-uppercase'}>{module.title}</h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <span>{module.metaDescription}</span>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default ModuleImageAndTitle;
